module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codepipeline-2015-07-09.paginators.json
// module id = 2285
// module chunks = 0